import { ActionHandler } from "..";
import { loadSubscriptionStatus } from "src/hooks/subscriptionStatus";
import { clinicalPlanIdPrefix, clinicalPlans } from "@utils/plansMapping";
import {
  clearProductSwitchData,
  setProductSwitchData,
} from "src/utils/redux/slices/productSwitch";
import getStore from "src/utils/redux/store";
import { queryProductSwitchOffers } from "src/api/productSwitchOffers";
import { setRecommendationContext } from "src/utils/redux/slices/recommendationContext";
import { getMedSKUByProductName } from "src/utils/plans";
import { SaleItemInfo } from "src/utils/redux/slices/checkoutOrders";

export async function loadAndStoreProductSwitchData() {
  try {
    const [subscriptionStatus, offers] = await Promise.all([
      loadSubscriptionStatus(),
      queryProductSwitchOffers(),
    ]);

    const planId = subscriptionStatus?.planId;
    const isInTrialPeriod = subscriptionStatus?.isInTrialPeriod ?? false;

    let currentProductName: string | null = null;
    if (planId) {
      if (planId.startsWith(clinicalPlanIdPrefix.compoundedMicrodose)) {
        currentProductName = clinicalPlans.compoundedMicrodose;
      } else if (planId.startsWith(clinicalPlanIdPrefix.compounded)) {
        currentProductName = clinicalPlans.compounded;
      } else if (
        planId.startsWith(clinicalPlanIdPrefix.compoundedTirzepatide)
      ) {
        currentProductName = clinicalPlans.compoundedTirzepatide;
      }
    }

    getStore().dispatch(
      setProductSwitchData({
        currentProductName,
        offers,
        isInTrialPeriod,
      })
    );

    const eligibleSaleItems: SaleItemInfo[] = offers.reduce<SaleItemInfo[]>(
      (items, offer) => {
        const medSku = getMedSKUByProductName(offer.productName);
        if (medSku) {
          items.push({
            medSku,
            saleItemId: offer.saleItemId,
            trialSaleItemId: isInTrialPeriod
              ? offer.trialSaleItemId
              : undefined,
            planName: offer.productName,
          });
        }
        return items;
      },
      []
    );

    getStore().dispatch(setRecommendationContext({ eligibleSaleItems }));
  } catch (error) {
    getStore().dispatch(clearProductSwitchData());
    getStore().dispatch(setRecommendationContext({ eligibleSaleItems: [] }));
  }
}

export const loadProductSwitchData: ActionHandler = async () => {
  await loadAndStoreProductSwitchData();
};
